<sgt-multi-select
  [settings]="settings"
  [options]="options"
  [(ngModel)]="idsCanaisVendas"
  (ngModelChange)="onChangeCanaisVendas()"
  (search)="onSearch()"
>
</sgt-multi-select>
